import React from 'react';
import DeleteButton from './DeleteButton';

interface DeleteCellColumnProps {
  row: {
    original: {
      id: any;
      canEdit?: boolean;
    };
  };
  cell: { value: (id: any) => void };
}

const DeleteCellColumn = ({
  row: {
    original: { id, canEdit },
  },
  cell: { value: handleDelete },
}: DeleteCellColumnProps) =>
  canEdit ? <DeleteButton onClick={() => handleDelete(id)} /> : null;

export default DeleteCellColumn;
